import type { CreativeForm } from '../form';

export enum CreativeTypeEnum {
  THIRD_PARTY = 'THIRD_PARTY',
  MEDIA_FILE = 'MEDIA_FILE',
  CLIENT_SUPPLY = 'CLIENT_SUPPLY',
  HEADER_BIDDER = 'HEADER_BIDDER',
  SMART_SERVER_BIDDING = 'SMART_SERVER_BIDDING',
  DEAL = 'DEAL',
  AMAZON_TAM = 'AMAZON_TAM',
  AMAZON_TAM_DEAL = 'AMAZON_TAM_DEAL',
  AMAZON_PMP = 'AMAZON_PMP',
}

export const CREATIVE_TYPE_OPTIONS: Array<{ label: string; value: CreativeTypeEnum }> = [
  { label: 'Prebid.js', value: CreativeTypeEnum.HEADER_BIDDER },
  { label: '3rd party tag', value: CreativeTypeEnum.THIRD_PARTY },
  { label: 'Smart server bidding', value: CreativeTypeEnum.SMART_SERVER_BIDDING },
  { label: 'Media asset', value: CreativeTypeEnum.MEDIA_FILE },
  { label: 'Deal', value: CreativeTypeEnum.DEAL },
  { label: 'JS API defined', value: CreativeTypeEnum.CLIENT_SUPPLY },
  { label: 'Amazon TAM/UAM', value: CreativeTypeEnum.AMAZON_TAM },
  { label: 'Amazon TAM - Deals', value: CreativeTypeEnum.AMAZON_TAM_DEAL },
  { label: 'Amazon private auction (PMP)', value: CreativeTypeEnum.AMAZON_PMP },
];

export const CREATIVE_TYPE_LABELS: Record<CreativeTypeEnum, string> = {
  [CreativeTypeEnum.HEADER_BIDDER]: 'Prebid.js',
  [CreativeTypeEnum.THIRD_PARTY]: '3rd party tag',
  [CreativeTypeEnum.SMART_SERVER_BIDDING]: 'Smart server bidding',
  [CreativeTypeEnum.MEDIA_FILE]: 'Media asset',
  [CreativeTypeEnum.DEAL]: 'Deal',
  [CreativeTypeEnum.CLIENT_SUPPLY]: 'JS API defined',
  [CreativeTypeEnum.AMAZON_TAM]: 'Amazon TAM/UAM',
  [CreativeTypeEnum.AMAZON_TAM_DEAL]: 'Amazon TAM - Deals',
  [CreativeTypeEnum.AMAZON_PMP]: 'Amazon private auction (PMP)',
};

export interface CreativeInventorySettings {
  placement: PlacementValue;
  startDelay: StartDelayValue;
}

export type PlacementValue = 'IN_STREAM' | 'IN_ARTICLE';

export const placementsOptions: { label: string; value: PlacementValue }[] = [
  { label: 'In-stream', value: 'IN_STREAM' },
  { label: 'In-article', value: 'IN_ARTICLE' },
];

export type StartDelayValue = 'AUTOMATIC_DETECTION' | 'PRE_ROLL' | 'MID_ROLL' | 'POST_ROLL';

export const startDelayOptions: { label: string; value: StartDelayValue }[] = [
  { label: 'Automatic detection', value: 'AUTOMATIC_DETECTION' },
  { label: 'Pre‑Roll', value: 'PRE_ROLL' },
  { label: 'Mid‑Roll', value: 'MID_ROLL' },
  { label: 'Post‑Roll', value: 'POST_ROLL' },
];

export interface AmazonTamPrices {
  code: string;
  price: number;
}

export interface CsvParseResult {
  success: boolean;
  data?: AmazonTamPrices[];
  error?: string;
}

export const CREATIVE_MOCK_DATA: CreativeForm = {
  id: '123abc',
  name: 'Test Creative',
  type: CreativeTypeEnum.THIRD_PARTY,
  url: 'https://example.com/creative',
  gdprvId: '123',
  shouldRenderVpaidInSecureIframe: true,
  inventorySettings: {
    placement: 'IN_STREAM',
    startDelay: 'AUTOMATIC_DETECTION',
  },
};
